import { forwardRef } from 'react'
import { CustomSpinner } from '../CustomSpinner'
import { Icon } from '../Icon'
import { StyledButton } from './styles'

export const Botao = forwardRef(
  (
    {
      id,
      width,
      height,
      padding,
      title,
      icon,
      iconSize,
      color,
      isDisabled,
      isLoading,
      loadingText,
      alignX,
      type,
      onClick,
    },
    ref,
  ) => {
    return (
      <StyledButton
        id={id}
        ref={ref}
        type={type}
        $w={width}
        $h={height}
        $p={padding}
        $color={color}
        $alignX={alignX}
        disabled={isDisabled || isLoading}
        onClick={onClick}
      >
        {isLoading ? (
          <>
            <CustomSpinner
              size={25}
              color="white"
            />
            <h1>{loadingText}</h1>
          </>
        ) : (
          <>
            {icon && (
              <Icon
                weight="fill"
                size={iconSize || 25}
                iconName={icon}
              />
            )}

            <h1
              style={{
                all: 'unset',
              }}
            >
              {title}
            </h1>
          </>
        )}
      </StyledButton>
    )
  },
)
